"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RestateMessageType;
(function (RestateMessageType) {
    RestateMessageType["INIT"] = "@Restate/Core/Init";
    RestateMessageType["UPDATE"] = "@Restate/Core/Update";
})(RestateMessageType = exports.RestateMessageType || (exports.RestateMessageType = {}));
exports.RESTATE_UPDATE_MESSAGE = {
    type: RestateMessageType.UPDATE
};
exports.RESTATE_INIT_MESSAGE = {
    type: RestateMessageType.INIT
};
//# sourceMappingURL=message.js.map